import React from 'react';
import HRDashboardPage from '../../pages/hr/dashboard';
import ProtectedRoute from '../protected';

export const HRDashboardRoutes = [
  <ProtectedRoute exact path='/dashboard' component={HRDashboardPage} />,
];
